import React, { useEffect, useState } from "react";
import spinner from "../../assets/images/spinner.gif";
import { Modal } from "@mui/material";
import { TrashIcon, XIcon } from "@heroicons/react/solid";
import Moment from "react-moment";
import Pagination from "../../components/pagination";
import Cookies from "universal-cookie";
import { ROLE } from "../../config";
import useLeaveStructure from "../../hooks/leaveStructure/useLeaveStructure";
import AddLeaveManagementModal from "./AddLeaveManagementModal";
import Spinner from "../../components/loader/Spinner";
import InlineLoader from "../../components/loader/InlineLoader";
import { Button } from "../../components/ui";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../../components/table/Table";
import RoundedContainer from "../../components/containers/RoundedContainer";

const cookies = new Cookies();

function LeaveManagement({ id, year }) {
  const {
    isLoading,
    isAddingData,
    isDeleting,
    pageNo,
    firstDate,
    lastDate,
    deleteConfirmationModal,
    leaveManagementList,
    userdata,
    paramsObject,
    formatDate,
    handlePageClick,
    handleOpenDeleteModal,
    handleDeleteLeave,
    submitLeaveManagementForm,
    setDeleteConfirmationModal,
    leaveStructureData,
    isLeaveStructureLoading,
    addLeaveManagementModal,
    setAddLeaveManagementModal,
    isUserDataLoading,
    calculateAvailableLeaves,
  } = useLeaveStructure({ id, year });

  const [role, setRole] = useState("");
  useEffect(() => {
    setRole(cookies.get(ROLE));
  }, []);

  const handleSubmitFormData = (leaveStructureData) => {
    submitLeaveManagementForm(leaveStructureData);
  };

  // Show spinner when page is loading
  if (isLoading) {
    return <Spinner />;
  }

  return (
    <>
      <div className="flex items-end justify-between px-4">
        <Button onClick={() => setAddLeaveManagementModal(true)}>
          + Add Leave Management
        </Button>
      </div>
      <div className="max-w-full mx-4">
        {leaveManagementList.data?.data?.length <= 0 ? (
          <div className="text-center">
            <p className="text-gray-700 text-3xl">No Data Found</p>
          </div>
        ) : (
          <>
            <RoundedContainer>
              <Table className="table-auto w-full">
                <TableHead>
                  <TableHeaderCell className="w-[8%] text-center hidden lg:table-cell">
                    Sr.No
                  </TableHeaderCell>
                  <TableHeaderCell className="w-[28%]">
                    Name
                  </TableHeaderCell>
                  <TableHeaderCell className="w-[18%] text-center">
                    From Date
                  </TableHeaderCell>
                  <TableHeaderCell className="w-[18%] text-center">
                    To Date
                  </TableHeaderCell>
                  <TableHeaderCell className="w-[10%] text-center">
                    Annual
                  </TableHeaderCell>
                  <TableHeaderCell className="w-[10%] text-center">
                    Remaining
                  </TableHeaderCell>
                  {/* <TableHeaderCell className="w-[10%] text-center">
                    Status
                  </TableHeaderCell> */}
                  <TableHeaderCell className="w-[8%] text-center">
                    Action
                  </TableHeaderCell>
                </TableHead>
                <TableBody>
                  {leaveManagementList.data?.data?.map((data, idx) => {
                    const {
                      id,
                      leave_head_name,
                      from_date,
                      to_date,
                      annual,
                      by_default,
                      remaining,
                    } = data;
                    return (
                      <TableRow key={idx}>
                        <TableCell className="text-center text-dark font-medium text-sm hidden lg:table-cell">
                          {pageNo * paramsObject?.limit + idx + 1}
                        </TableCell>
                        <TableCell className="text-dark font-medium text-sm">
                          {leave_head_name}
                        </TableCell>
                        <TableCell className="text-center text-dark font-medium text-sm">
                          <Moment format="DD/MM/YYYY">
                            {from_date * 1000}
                          </Moment>
                        </TableCell>
                        <TableCell className="text-center text-dark font-medium text-sm">
                          <Moment format="DD/MM/YYYY">{to_date * 1000}</Moment>
                        </TableCell>
                        <TableCell className="text-center text-dark font-medium text-sm">
                          {annual}
                        </TableCell>
                        <TableCell className="text-center text-dark font-medium text-sm">
                          {remaining}
                        </TableCell>
                        {/* <TableCell
                          className={`text-center font-medium text-sm ${
                            by_default === "Active"
                              ? "text-green-500"
                              : "text-red-500"
                          }`}
                        >
                          {by_default}
                        </TableCell> */}
                        <TableCell className="text-center">
                          <Button
                            variant="ghost"
                            size="icon"
                            onClick={() => handleOpenDeleteModal(id)}
                          >
                            <TrashIcon className="text-gray-500 w-5 h-5 hover:text-red-600 transition-colors" />
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </RoundedContainer>
            <RoundedContainer>
              <Pagination
                currentPage={+paramsObject.page_no}
                lengthofItems={leaveManagementList.data?.total_count}
                limit={paramsObject.limit}
                onPageChange={handlePageClick}
              />
            </RoundedContainer>
          </>
        )}
      </div>

      {/* Add Leave Management Modal */}
      <AddLeaveManagementModal
        isOpen={addLeaveManagementModal}
        onClose={() => setAddLeaveManagementModal(false)}
        onSubmit={handleSubmitFormData}
        isSubmitting={isAddingData}
        userData={userdata}
        firstDate={firstDate}
        lastDate={lastDate}
        formatDate={formatDate}
        leaveStructureData={leaveStructureData}
        isLeaveStructureLoading={isLeaveStructureLoading}
        isUserDataLoading={isUserDataLoading}
        calculateAvailableLeaves={calculateAvailableLeaves}
      />

      <Modal open={deleteConfirmationModal}>
        <div className="w-[60%] bg-white absolute left-1/2 -translate-x-1/2 top-[20%]">
          <div className="document-wrapper px-4 divide-y">
            <div className="document-head py-4">
              <div className="flex items-center justify-between">
                <h3 className=" text-gray-700 text-3xl font-semibold">
                  Delete Leave Structure
                </h3>
                <Button
                  variant={"ghost"}
                  size={"icon"}
                  className=" w-6 h-6 cursor-pointer"
                  onClick={() => setDeleteConfirmationModal(false)}
                >
                  <XIcon className=" text-black w-full h-full" />
                </Button>
              </div>
            </div>
            <div className="document-body max-h-96 overflow-auto py-4">
              <div>
                <p className=" roboto text-center font-bold text-2xl text-gray-700 mb-4">
                  Are you sure you want to delete this leave structure?
                </p>
                <div className="flex justify-center space-x-5 text-center">
                  <Button
                    className="font-semibold bg-red-200 text-red-700 border-red-800"
                    onClick={handleDeleteLeave}
                    disabled={isDeleting}
                  >
                    {isDeleting ? (
                      <>
                        <InlineLoader className="text-red-700 mr-2" />{" "}
                        Deleting...
                      </>
                    ) : (
                      "Yes, Delete"
                    )}
                  </Button>
                  <Button
                    className="font-semibold"
                    variant={"outline"}
                    onClick={() => setDeleteConfirmationModal(false)}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default LeaveManagement;
